var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[(_vm.os != 'mini')?_c('van-nav-bar',{staticClass:"buying-navbar",attrs:{"title":"充值完成","fixed":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }